/**
 * @generated SignedSource<<b85c249a7f243b3a72b0b5d4b0a6bb57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InspectionForm_data$data = {
  readonly id: string;
  readonly inspectionfield: {
    readonly externalId: number | null;
    readonly field: {
      readonly periodEnd: any;
      readonly periodStart: any;
    } | null;
    readonly id: string;
    readonly inspector: {
      readonly firstName: string;
      readonly lastName: string;
      readonly user: {
        readonly firstName: string;
        readonly lastName: string;
      } | null;
    } | null;
    readonly managementPackageVariant: {
      readonly code: string;
      readonly managementPackage: {
        readonly name: string;
      } | null;
      readonly name: string;
    } | null;
    readonly member: {
      readonly address: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly city: string | null;
            readonly houseNumber: number | null;
            readonly street: string | null;
            readonly zipcode: string | null;
          } | null;
        } | null>;
      };
      readonly email: string | null;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null;
    } | null;
    readonly periodEnd: any | null;
    readonly periodStart: any | null;
    readonly plannedDate: any | null;
  };
  readonly " $fragmentType": "InspectionForm_data";
};
export type InspectionForm_data$key = {
  readonly " $data"?: InspectionForm_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionForm_data">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodStart",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "periodEnd",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionForm_data",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionfieldNode",
      "kind": "LinkedField",
      "name": "inspectionfield",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "plannedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InspectorNode",
          "kind": "LinkedField",
          "name": "inspector",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UserNode",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectNode",
          "kind": "LinkedField",
          "name": "managementPackageVariant",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "code",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ManagementPackageNode",
              "kind": "LinkedField",
              "name": "managementPackage",
              "plural": false,
              "selections": [
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberNode",
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phone",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AddressNodeConnection",
              "kind": "LinkedField",
              "name": "address",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AddressNodeEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AddressNode",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "street",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "houseNumber",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "zipcode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "city",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FieldNode",
          "kind": "LinkedField",
          "name": "field",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionNode",
  "abstractKey": null
};
})();

(node as any).hash = "2a0a27057353cd15f9e70cef4b52234c";

export default node;
